/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/bell-ring
 */
import { default as DefaultIcon } from '~icons/lucide/bell-ring';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const BellRingIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
